/* VALKA · Volver arriba con anillo de avance. */
(() => {
  if (customElements.get('valka-x-back-to-top')) return;

  class ValkaBackToTop extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.offset = Math.max(0, parseInt(this.dataset.offset, 10) || 0);
      this.visible = false;

      this.update = this.update.bind(this);
      this.onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        window.requestAnimationFrame(() => {
          this.ticking = false;
          this.update();
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });

      this.button.addEventListener('click', () => {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
        // Llevar el foco al inicio para usuarios de teclado y lectores de pantalla.
        const target = document.getElementById('MainContent') || document.querySelector('main');
        if (target) {
          if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
        }
      });

      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    update() {
      const y = window.scrollY || document.documentElement.scrollTop;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const progress = max > 0 ? Math.min(100, Math.max(0, (y / max) * 100)) : 0;
      this.style.setProperty('--vx-progress', progress.toFixed(1));

      const show = y > Math.max(this.offset, 1);
      if (show === this.visible) return;
      this.visible = show;
      this.classList.toggle('is-visible', show);
      this.button.setAttribute('tabindex', show ? '0' : '-1');
      if (show) {
        this.button.removeAttribute('aria-hidden');
      } else {
        this.button.setAttribute('aria-hidden', 'true');
      }
    }
  }

  customElements.define('valka-x-back-to-top', ValkaBackToTop);
})();
